import Default from '@/resources/themes/checkout/default/Default';

import { PageContext } from '../../components/contexts/PageContext';
import { useTemplateByPage } from '../../hooks/useTemplateByPage';

function Checkout() {
  const template = useTemplateByPage('checkout');

  const renderCheckoutTemplate = () => {
    switch (template?.template_name) {
      default:
        return <Default />;
    }
  };

  return (
    <PageContext.Provider value={{ template }}>{renderCheckoutTemplate()}</PageContext.Provider>
  );
}

export default Checkout;
